import { useState, useEffect } from 'react';
import MuiRadio from '@mui/material/Radio';
import FormControlLabel from '@mui/material/FormControlLabel';

import * as Styles from './Radio.styles';

const Radio = ({
  formik,
  defaultValue,
  name,
  options,
  onChange,
  row = true,
  ...rest
}) => {
  const [value, setValue] = useState(formik?.values?.[name] || defaultValue);

  useEffect(() => {
    if (formik && formik?.values?.[name]) {
      setValue(formik.values[name]);
    }
  }, [formik?.values?.[name], value]);

  const handleChange = (event) => {
    setValue(event.target.value);
    if (onChange) {
      onChange(event.target.value);
    }
    if (formik) {
      formik.handleChange(event);
    }
  };

  return (
    <Styles.Radio
      {...rest}
      row={row}
      aria-labelledby="demo-radio-buttons-group-label"
      value={value}
      onChange={handleChange}
      name={name}
    >
      {options?.map((option) => (
        <FormControlLabel
          key={`${name}-${option.value}`}
          value={option.value}
          control={<MuiRadio />}
          label={option.label}
        />
      ))}
    </Styles.Radio>
  );
};

export default Radio;
